import { assert, log } from '../app/logger.js';
import { settings } from '../app/settings.js';
import { Dialog } from '../controls/dialog.js';
import { window } from '../window.js';

/**
 * Process pics dialog.
 */
class MediaProcessingDialog extends Dialog {
  increment() {
    this.picCurrentElement.textContent = ++this.#current;
    if (this.#current == this.#mediaCount) {
      this.cancelButton.textContent = this.constructor.doneLabel;
      log(`[map:media] finished processing media file(s)`);
    }
  }

  show(mediaCount) {
    assert(mediaCount !== undefined, `[map:media] no mediaCount`);
    log(`[map:media] processing ${mediaCount} media file(s)`);

    settings.bindUI('mediaProcessingDialogAutoHide');

    this.#current = 0;
    this.#mediaCount = mediaCount;

    this.picCurrentElement.textContent = 0;
    this.mediaCountElement.textContent = mediaCount;
    this.cancelButton.textContent = this.constructor.hideLabel;

    return super.show();
  }

  static titleMarkup = `Media analysis`;

  static bodyMarkup = `
    <form class='default'>
      <label>
        The images will be grouped by geo coordinates (if any) and
        placed on the map. If the images have no GPS info, then they
        will be aligned according to a provided GPX track if any, otherwise
        a signle marker will be created in the center of the map.
      </label>
      <label class='hide-when-done-label'>
        <input type='checkbox' pref='mediaProcessingDialogAutoHide'>
        Hide when done
      </label>
      <label class='progress-label'>
        Processing media <span class='current-media'></span> of <span class='media-count'></span>.
      </label>
    </form>
  `;

  static get buttons() {
    return {
      cancel: {
        label: this.hideLabel,
      },
    };
  }

  static get selectors() {
    return Object.assign({}, super.selectors, {
      MediaCount: '.media-count',
      CurrentMedia: '.current-media',
    });
  }

  static get elements() {
    return {
      mediaCountElement: '.media-count',
      picCurrentElement: '.current-media',
    };
  }

  static doneLabel = 'Done';
  static hideLabel = 'Hide';

  #current;
  #mediaCount;
}

window.customElements.define('media-processing-dialog', MediaProcessingDialog);

export { MediaProcessingDialog };
